import React from "react";
import { COLORS } from "../types/profession.types";

interface TabButtonProps {
  active: boolean;
  onClick: () => void;
  color: string;
  children: React.ReactNode;
}

export const TabButton: React.FC<TabButtonProps> = ({
  active,
  onClick,
  color,
  children,
}) => (
  <button
    onClick={onClick}
    className="bg-transparent border-0 pb-3 px-1"
    style={{
      color: active ? color : COLORS.textLight,
      borderBottom: active ? `2px solid ${color}` : "2px solid transparent",
      transition: "all 0.2s ease",
      cursor: "pointer",
      fontSize: "1rem",
      padding: "0.5rem 0.25rem",
    }}
  >
    {children}
  </button>
);